import { Injectable } from '@angular/core';
import ParcelSearchByOwnerRequest from '@app/models/parcel-search-by-owner-request';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: "root"
})
export class ParcelService {
  private readonly _componentName = 'ParcelService';

  constructor(private http: HttpClient) {}

  public getParcelsByOwnerName(request: ParcelSearchByOwnerRequest) {
    const url = 'parcel/search/owner';

    return this.http.post<any>(url, request);
  }
}
